import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, Message, SelectItem, TreeNode } from 'primeng/api';
import { Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { CuentaContable } from '../../_models/cuenta-contable';
import { CuentaContableService } from '../../_services/cuenta-contable.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuncionalidadControl } from '../../_models/funcionalidad-control';
import { forkJoin } from 'rxjs';
import { CuentaContableControlService } from '../../_services/cuenta-contable-control.service';
import { CuentaContableControl } from '../../_models/cuenta-contable-control';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';

@Component( {
  selector: 'app-cuenta-contable',
  templateUrl: 'cuenta-contable.component.html'
} )
export class CuentaContableComponent implements OnInit {


  msg: Message;
  /**
   * lista de grupos bienes
   * @type {Array}
   */
  cuentasContables: CuentaContable[] = [];
  /**
   * grupo bien
   * @type {Properties}
   */
  cuentaContable: CuentaContable;
  treeProperties: TreeNode[] = [];
  nodeSelected: TreeNode;
  treeselected: TreeNode;
  tabselected = 1;
  header: string;
  labelPadre: string;
  codeExists = false;
  displayDialog = false;
  submitted = false;
  guardado = false;
  disableHab = true;
  btn: { show: boolean, label: string };
  btnsub: { show: boolean, label: string } = {
    show: false,
    label: ''
  };
  loadingTree = true;
  loadingData = true;
  menu: Funcionalidad = new Funcionalidad();
  formulario: FormGroup;
  lisFuncionalidadesControlesTodos: FuncionalidadControl[] = [];
  lisFuncionalidadControl: SelectItem[] = [];
  lisEstadosFinancierosTodos: ListaItem[] = [];
  lisEstadosFinancieros: SelectItem[] = [];
  lisControlesTodos: FuncionalidadControl[] = [];
  lisControl: SelectItem[] = [];
  cuentasContablesControles: CuentaContableControl[] = [];
  controlesCargados = true;
  columnas: any[];
  carTabla = false;
  tablaCuentasContablesControles: CuentaContableControl[] = [];
  cuentaContCrezcamosPadre: number;
  ranIncorrecto = false;

  constructor( private router: Router,
               private serCuentaContable: CuentaContableService,
               private navService: NavService,
               private autServicio: AutenticacionService,
               private confirmationService: ConfirmationService,
               private fb: FormBuilder,
               private funServicio: FuncionalidadesService,
               private serCuentaContableControl: CuentaContableControlService,
               private serListas: ListaService ) {
  }

  ngOnInit() {
    this.btn = {
      show: true,
      label: this.navService.buscarMensaje( 'BIENES.BTN_AGREGARGRUPO' )
    };

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'asi/grupo-bien' );
    if ( mn ) {
      this.menu = mn;
    }

    this.serCuentaContable.listado().subscribe( res => {
      this.cuentasContables = res;
      this.cuentasContables.sort( function( a, b ) {
        return a.cuentaContableCrezcamos - b.cuentaContableCrezcamos;
      } );
      for ( let c of this.cuentasContables.filter( t => t.idCuentaContablePadre === null && t.indicadorHabilitado === true ) ) {
        c.nivelCuentaContable = 1;
        this.treeProperties.push( {
          'label': c.cuentaContableCrezcamos + ' ' + c.descripcionCuenta,
          'data': c,
          'children': [ {
            'label': '+ ' + this.navService.buscarMensaje( 'LBL_CARGANDO' ) + '...',
            'data': ''
          }
          ]
        } );
      }
      this.loadingTree = false;
      this.loadingData = false;
    } );
    this.formulario = this.fb.group( {
      idCuentaContable: [ null ],
      idCuentaContablePadre: [ null ],
      cuentaContable: [ null ],
      cuentaContableCrezcamos: [ null, [ Validators.required ] ],
      descripcionCuenta: [ null, [ Validators.required ] ],
      idTipoEstadoFinanciero: [ null, [ Validators.required ] ],
      indicadorSuma: [ null ],
      nivelCuentaContable: [ null, [ Validators.required ] ],
      indicadorVisible: [ null ],
      indicadorHabilitado: [ null, [ Validators.required ] ],
      codigoHojaEvaluacion: [ null , [ Validators.required ]],
      descripcionCuentaPadre: [ null ],
      seccion: [ null ],
      idFuncionalidadControl: [ null ]
    } );

    forkJoin( this.funServicio.obtenerFuncionalidadesControlesPorCodigoFuncionalidad( 'CUENCONT' ),
      this.serListas.getMasterDetails( 'ListasTiposEstadosFinancieros' ) ).subscribe( ( [ lisFuncionaliadesControles, estadosFinancieros ] ) => {
      this.lisFuncionalidadesControlesTodos = lisFuncionaliadesControles;
      this.lisEstadosFinancierosTodos = estadosFinancieros;

      this.cargarListadoFormularios();
    } );

    this.columnas = [
      { field: 'seccion', header: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_SECCION' ), sort: false },
      { field: 'control', header: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_CONTROL' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.new();

  }


  /**
   * volver atras
   */
  goBack(): void {
    this.router.navigate( [ 'asi/grupos-bienes' ] );
  }

  get f() {
    return this.formulario.controls;
  }

  cargarCuentasContablesControles() {
    return this.tablaCuentasContablesControles.filter( x => x.indicadorHabilitado );
  }


  cargarListadoFormularios() {
    this.lisFuncionalidadControl = [];
    this.lisFuncionalidadesControlesTodos.map( ( s: FuncionalidadControl ) => {
      if ( s.indicadorSeccion ) {
        this.lisFuncionalidadControl.push( { label: s.nombre, value: s.idFuncionalidadControl } );
      }
    } );
    this.lisEstadosFinancierosTodos.map( ( s: ListaItem ) => {
      this.lisEstadosFinancieros.push( { label: s.nombre, value: s.idLista } );
    } );
  }

  verificarFuncionalidad( row?: any ) {
    this.controlesCargados = false;
    this.lisControl = [];
    this.funServicio.getFieldByIdFather( row ? row.idFuncionalidadControlPadre : this.f.seccion.value ).subscribe( controles => {
      this.serCuentaContableControl.listado().subscribe( cuentasControles => {
        this.cuentasContablesControles = cuentasControles;
        this.lisControlesTodos = controles;
        this.lisControlesTodos.map( ( s: FuncionalidadControl ) => {
          if ( !this.cuentasContablesControles.find( y => y.idFuncionalidadControl === s.idFuncionalidadControl && y.indicadorHabilitado ) ) {
            if ( this.tablaCuentasContablesControles.length > 0 ) {
              if ( !this.tablaCuentasContablesControles.find( y => y.idFuncionalidadControl === s.idFuncionalidadControl && y.indicadorHabilitado ) ) {
                this.lisControl.push( { label: s.nombre, value: s.idFuncionalidadControl } );
              }
            } else {
              this.lisControl.push( { label: s.nombre, value: s.idFuncionalidadControl } );
            }
          } else if ( this.cuentasContablesControles.find( y => y.idFuncionalidadControl === s.idFuncionalidadControl && y.indicadorHabilitado ) && this.tablaCuentasContablesControles.find( y => y.idFuncionalidadControl === s.idFuncionalidadControl && !y.indicadorHabilitado ) ) {
            this.lisControl.push( { label: s.nombre, value: s.idFuncionalidadControl } );
          }
        } );
        this.controlesCargados = true;
      } );
    } );
  }


  new() {
    this.submitted = false;
    this.cuentaContable = {} as CuentaContable;
    this.tabselected = 1;
    this.header = this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_CUENTAS' );
    this.cuentaContable.nivelCuentaContable = 1;
    this.cuentaContable.idCuentaContablePadre = null;
    this.cuentaContable.indicadorSuma = null;
    this.cuentaContable.indicadorVisible = true;
    this.cuentaContable.idTipoEstadoFinanciero = null;
    this.labelPadre = '';
    this.codeExists = false;
    this.guardado = false;
    this.disableHab = true;
    this.cuentaContable.indicadorHabilitado = true;
    this.tablaCuentasContablesControles = [];
    this.formatearSub();

  }

  newSub() {

    this.submitted = false;
    this.cuentaContable = {} as CuentaContable;
    this.labelPadre = '';
    if ( this.nodeSelected.data ) {
      this.tabselected = this.nodeSelected.data.nivelCuentaContable;
      this.header = this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_CUENTAS' );
      this.cuentaContable.nivelCuentaContable = this.nodeSelected.data.nivelCuentaContable + 1;
      this.cuentaContable.descripcionCuentaPadre = this.nodeSelected.data.descripcionCuenta;
      this.cuentaContable.idCuentaContablePadre = this.nodeSelected.data.idCuentaContable;
      this.cuentaContCrezcamosPadre = this.nodeSelected.data.cuentaContableCrezcamos;
      this.cuentaContable.idTipoEstadoFinanciero = this.nodeSelected.data.idTipoEstadoFinanciero;
      this.cuentaContable.tipoEstadoFinanciero = this.nodeSelected.data.tipoEstadoFinanciero;
      this.disableHab = true;
    }
    this.codeExists = false;
    this.guardado = false;
    this.cuentaContable.indicadorHabilitado = true;
    (this.tabselected > 1) ? this.cuentaContable.indicadorSuma = true : this.cuentaContable.indicadorSuma = null;
    this.cuentaContable.indicadorVisible = true;
    this.tablaCuentasContablesControles = [];
    this.formatearSub();
  }

  formatearSub( cuentaContable?: CuentaContable ) {
    this.formulario.reset();
    this.f.indicadorHabilitado.setValue( this.cuentaContable.indicadorHabilitado );
    this.f.indicadorSuma.setValue( this.cuentaContable.indicadorSuma );
    this.f.indicadorVisible.setValue( this.cuentaContable.indicadorVisible );
    this.f.nivelCuentaContable.setValue( this.cuentaContable.nivelCuentaContable );
    this.f.idCuentaContablePadre.setValue( this.cuentaContable.idCuentaContablePadre );
    this.f.descripcionCuenta.setValue( this.cuentaContable.descripcionCuenta );
    this.f.cuentaContable.setValue( this.cuentaContable.cuentaContable );
    this.f.cuentaContableCrezcamos.setValue( this.cuentaContable.cuentaContableCrezcamos );
    this.f.descripcionCuentaPadre.setValue( this.cuentaContable.idCuentaContablePadre ? this.cuentaContable.descripcionCuentaPadre = this.cuentasContables.find( x => x.idCuentaContable === this.cuentaContable.idCuentaContablePadre ).descripcionCuenta : null );
    this.f.idCuentaContable.setValue( this.cuentaContable.idCuentaContable );
    this.f.idTipoEstadoFinanciero.setValue( this.cuentaContable.idTipoEstadoFinanciero );
    this.f.codigoHojaEvaluacion.setValue( this.cuentaContable.codigoHojaEvaluacion ? this.cuentaContable.codigoHojaEvaluacion : null);
  }


  nodeExpand( node
                :
                any
  ) {
    let expandChils: any[] = [];
    let chil: any;
    let tabselected = node.data.nivelCuentaContable;

    if ( tabselected > 9 ) {
      chil = [];
    } else {
      chil = [ { 'label': '+ ' + this.navService.buscarMensaje( 'LBL_CARGANDO' ) + '...', } ];
    }

    for ( let c of this.cuentasContables.filter( t => t.idCuentaContablePadre === node.data.idCuentaContable && t.indicadorHabilitado === true ) ) {
      expandChils.push( {
        'label': c.cuentaContableCrezcamos + ' ' + c.descripcionCuenta,
        'data': c,
        'parent': node,
        'children': chil
      } );
    }
    node.children = expandChils;

  }

  preSelect( node
               :
               any
  ) {
    if ( this.formulario.dirty ) {
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CAMBIAR' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          // this.form.resetForm();
          this.formulario.reset();
          this.nodeSelect( node );

        },
        reject: () => {
          this.nodeSelected = this.treeselected;
        }
      } );
    } else {
      this.nodeSelect( node );
    }
  }

  nodeSelect( node: any ) {
    this.formulario.reset();
    this.loadingData = true;
    this.guardado = false;
    this.disableHab = false;
    this.treeselected = node;
    this.tabselected = node.data.nivelCuentaContable;
    this.tablaCuentasContablesControles = [];
    if ( this.tabselected > 10 || this.tabselected < 0 ) {
      this.btnsub.show = false;
    } else {
      this.btnsub.show = true;
      this.btnsub.label = this.navService.buscarMensaje( 'CUENTACONTABLE.BTN_CUENTHIJO' );
    }

    this.cuentaContable = this.cuentasContables.find( t => t.idCuentaContable === node.data.idCuentaContable );
    this.f.idCuentaContable.setValue( (this.cuentaContable.idCuentaContable !== null && (this.cuentaContable.idCuentaContable !== '' && this.cuentaContable.idCuentaContable !== null && this.cuentaContable.idCuentaContable !== undefined)) ? this.cuentaContable.idCuentaContable : null );
    this.f.idCuentaContablePadre.setValue( this.cuentaContable.idCuentaContablePadre );
    this.f.cuentaContable.setValue( this.cuentaContable.cuentaContable );
    this.f.cuentaContableCrezcamos.setValue( this.cuentaContable.cuentaContableCrezcamos );
    this.f.descripcionCuenta.setValue( this.cuentaContable.descripcionCuenta );
    this.f.indicadorSuma.setValue( this.cuentaContable.indicadorSuma );
    this.f.nivelCuentaContable.setValue( this.cuentaContable.nivelCuentaContable );
    this.f.indicadorVisible.setValue( this.cuentaContable.indicadorVisible );
    this.f.indicadorHabilitado.setValue( this.cuentaContable.indicadorHabilitado );
    this.f.descripcionCuentaPadre.setValue( this.cuentaContable.descripcionCuentaPadre );
    this.f.idTipoEstadoFinanciero.setValue( this.cuentaContable.idTipoEstadoFinanciero );
    this.f.codigoHojaEvaluacion.setValue( this.cuentaContable ? this.cuentaContable.codigoHojaEvaluacion: null );
    this.header = this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_CUENTAS' );

    if ( this.tabselected > 2 ) {
      this.serCuentaContableControl.listadoPorIdCuentaContable( node.data.idCuentaContable ).subscribe( ccc => {
        if ( ccc && ccc.length > 0 ) {
          ccc.map( ( s: CuentaContableControl ) => {
            this.carTabla = true;
            const obj = {} as any;
            obj.idCuentaContableControl = s.idCuentaContableControl ? s.idCuentaContableControl : null;
            obj.idFuncionalidadControl = s.idFuncionalidadControl;
            obj.idFuncionalidadControlPadre = s.idFuncionalidadControlPadre;
            obj.idCuentaContable = s.idCuentaContable;
            obj.indicadorHabilitado = s.indicadorHabilitado;
            obj.funcionalidadControl = s.funcionalidadControl;
            obj.funcionalidadControlPadre = s.funcionalidadControlPadre;
            this.tablaCuentasContablesControles = [ ...this.tablaCuentasContablesControles, obj ];
            this.carTabla = false;
          } );
        } else {
          this.tablaCuentasContablesControles = [];
        }
      } );
    }

    this.serCuentaContable.obtenerPorId( node.data.idCuentaContable ).subscribe( dp => {
      this.cuentaContable = dp;
      if ( this.cuentaContable.indicadorHabilitado === false ) {
        this.btnsub.show = false;
      }

      this.loadingData = false;
    } );
  }

  guardarCuenta( formulario: any ) {
    formulario.descripcionCuentaPadre = this.cuentaContable.descripcionCuentaPadre;
    this.serCuentaContable.crear( formulario ).subscribe( data => {
      this.guardado = false;
      let typeMessage = 1; // 1 = Addmessage, this.msg );
      this.navService.setMesage( typeMessage );
      let chil: any[] = [];
      if ( this.tabselected < 2 ) {
        chil = [ {
          'label': '+ ' + this.navService.buscarMensaje( 'LBL_CARGANDO' ) + '...',
        }
        ];
      }
      let newChil: any = {
        'label': data.cuentaContableCrezcamos + ' ' + data.descripcionCuenta,
        'data': data,
        'children': chil
      };
      if ( this.tabselected > 1 ) {
        const listado: CuentaContableControl[] = [];
        this.tablaCuentasContablesControles.map( s => {
          if ( s.indicadorHabilitado ) {
            const objeto = {} as CuentaContableControl;
            objeto.idCuentaContable = data.idCuentaContable;
            objeto.idFuncionalidadControl = s.idFuncionalidadControl;
            objeto.indicadorHabilitado = s.indicadorHabilitado;
            listado.push( objeto );
          }
        } );
        this.serCuentaContableControl.bulk( listado ).subscribe( cRIXD => {
          this.submitted = false;
          this.guardado = false;
          this.cuentaContable = data;
          this.formatearSub();
        } );
      } else {
        this.submitted = false;
        this.guardado = false;
        this.tablaCuentasContablesControles = [];
        this.cuentaContable = data;
        this.formatearSub();
      }
      this.cuentasContables.push( data );
      if ( data.idCuentaContablePadre === null ) {
        this.treeProperties.push( newChil );
        this.new();
      } else {
        this.nodeSelected.children.push( newChil );
        this.newSub();
      }


    }, error => {
      this.guardado = false;
      let typeMessage = 3; // 1 = Add, 2 = Update, 3 = Error, 4 Custom
      this.navService.setMesage( typeMessage );
    } );
  }

  onSubmit() {
    this.submitted = true;

    if ( this.formulario.valid  && !this.ranIncorrecto) {
      const formulario = this.formulario.getRawValue();
      if ( this.cuentaContable.idCuentaContable === null ||
        this.cuentaContable.idCuentaContable === '' ||
        this.cuentaContable.idCuentaContable === undefined ) {
        /** Crear cuenta contable */
        this.guardado = true;
        const cuenCont = this.cuentasContables.find( x => x.cuentaContableCrezcamos == this.f.cuentaContableCrezcamos.value );
        if ( cuenCont ) {
          /** Existe codigo de la cuenta contable */
          this.guardado = false;
          this.navService.setMesage( 0, {
            severity: 'error', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_ERRORCODIGO' )
          } );
        } else {
          /** Codigo de la cuenta contable nivel 1 es mayor a 9 */
          if ( this.tabselected === 1 && Number( formulario.cuentaContableCrezcamos ) > 9 && formulario.idCuentaContablePadre === null ) {
            this.guardado = false;
            this.submitted = false;
            this.navService.setMesage( 0, {
              severity: 'error', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_ERRORCODCREZ' )
            } );
          } else {
            /** Crear cuenta contable */
            if ( this.tabselected > 0 && formulario.idCuentaContablePadre === null ) {
              this.guardarCuenta( formulario );
            } else {
              const subCuenta = this.f.cuentaContableCrezcamos.value.toString().substring( 0, this.cuentaContCrezcamosPadre.toString().length );
              if ( this.tabselected > 0 && formulario.idCuentaContablePadre !== null && subCuenta == this.cuentaContCrezcamosPadre ) {
                this.guardarCuenta( formulario );
              } else {
                this.guardado = false;
                this.submitted = false;
                this.navService.setMesage( 0, {
                  severity: 'error', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                  detail: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_ERRCODCRZPDR' )
                } );
              }
            }
          }
        }
      } else {
        /** Actualizar cuenta contable */
        this.guardado = true;
        // this.cuentaContable.nivelGrupoBien = 1;
        formulario.descripcionCuentaPadre = this.cuentaContable.descripcionCuentaPadre;
        this.serCuentaContable.actualizar( formulario ).subscribe( cuentaContableAct => {
          forkJoin(this.serCuentaContable.obtenerPorId(cuentaContableAct.idCuentaContable),
            this.serCuentaContable.actualizarHijos( cuentaContableAct.idCuentaContable ))
            .subscribe( ([cuentaContableActualizada, actualizados]) => {
            this.guardado = false;
            let typeMessage = 2; // 1 = Add, 2 = Update, 3 Error, 4 Custom
            this.navService.setMesage( typeMessage, this.msg );
            this.nodeSelected.label = formulario.cuentaContableCrezcamos + ' ' + formulario.descripcionCuenta;
            this.header = this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_CUENTAS' );
            for ( let i = 0; i < this.cuentasContables.length; i++ ) {
              if ( this.cuentasContables[ i ].idCuentaContable === formulario.idCuentaContable ) {
                this.cuentasContables[ i ] = cuentaContableActualizada;
              }
            }
            if ( cuentaContableActualizada.indicadorHabilitado === false ) {
              this.serCuentaContable.listado().subscribe( res => {
                this.cuentasContables = res;
              } );
            }
            if ( this.tabselected > 2 ) {
              const listado: CuentaContableControl[] = [];
              this.tablaCuentasContablesControles.map( s => {
                const objeto = {} as CuentaContableControl;
                objeto.idCuentaContableControl = s.idCuentaContableControl;
                objeto.idCuentaContable = cuentaContableActualizada.idCuentaContable;
                objeto.idFuncionalidadControl = s.idFuncionalidadControl;
                objeto.indicadorHabilitado = s.indicadorHabilitado;
                listado.push( objeto );
              } );
              this.serCuentaContableControl.bulk( listado ).subscribe( cRIXD => {
                this.submitted = false;
                this.guardado = false;
                this.cuentaContable = cuentaContableActualizada;
                this.formatearSub();
              } );
            } else {
              this.submitted = false;
              this.guardado = false;
              this.tablaCuentasContablesControles = [];
              this.cuentaContable = cuentaContableActualizada;
              this.formatearSub();
            }
          } );
        }, error => {
          this.guardado = false;
          let typeMessage = 3; // 1 = Add, 2 = Update, 3 = Error, 4 Custom
          this.navService.setMesage( typeMessage );
        } );
      }
    }
  }

  guardar() {
    this.carTabla = true;
    let idFuncionalidadControl = this.f.idFuncionalidadControl.value;
    if ( idFuncionalidadControl !== null && idFuncionalidadControl !== '' ) {
      if ( !this.tablaCuentasContablesControles.find( x => x.idFuncionalidadControl === idFuncionalidadControl ) ) {
        this.funServicio.getFuncionalidadControl( idFuncionalidadControl ).subscribe( control => {
          const obj = {} as CuentaContableControl;
          obj.idFuncionalidadControl = idFuncionalidadControl;
          obj.indicadorHabilitado = true;
          obj.idCuentaContable = null;
          obj.funcionalidadControl = control.nombre;
          obj.funcionalidadControlPadre = control.padre;
          this.tablaCuentasContablesControles = [ ...this.tablaCuentasContablesControles, obj ];
          this.carTabla = false;
        } );

      } else {
        if ( this.tablaCuentasContablesControles.find( x => x.idFuncionalidadControl === idFuncionalidadControl && !x.indicadorHabilitado ) ) {
          this.tablaCuentasContablesControles.map( s => {
            if ( s.idFuncionalidadControl === idFuncionalidadControl ) {
              s.indicadorHabilitado = true;
            }
          } );
        } else {
          this.navService.setMesage( 0, {
            severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_ERRORCONTROL' )
          } );
        }

      }
    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_INFOCONTROL' )
      } );
    }
    this.carTabla = false;
  }

  eliminarCuentaControl( row: any ) {
    this.carTabla = true;
    this.guardado = true;
    this.tablaCuentasContablesControles.map( s => {
      if ( s.idFuncionalidadControl === row.idFuncionalidadControl ) {
        s.indicadorHabilitado = false;
      }
    } );
    this.verificarFuncionalidad( row.idCuentaContable ? row : null );
    this.carTabla = false;
    this.guardado = false;

  }

  doCancel( fDirty: boolean ) {

    if ( fDirty ) {
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          // this.form.resetForm();
          this.loadingData = true;
          if ( this.cuentaContable.idCuentaContable === null || this.cuentaContable.idCuentaContable === '' || this.cuentaContable.idCuentaContable === undefined ) {
            if ( this.cuentaContable.idCuentaContablePadre === null ) {
              this.new();
            } else {
              this.newSub();
            }
            this.loadingData = false;
          } else {
            this.serCuentaContable.obtenerPorId( this.cuentaContable.idCuentaContable ).subscribe( res => {
              this.codeExists = false;
              this.cuentaContable = res;
              this.loadingData = false;
            } );
          }
          this.formulario.reset();
          this.formatearSub(this.cuentaContable);
        }
      } );
    } else {
      this.msg = {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ) + '!',
        detail: this.navService.buscarMensaje( 'MSG_NOHAYCAMBIOSDESCARTAR' )
      };
      this.navService.setMesage( 4, this.msg );
    }
  }

  validarNumero( event: any ) {
    const valor = this.formulario.controls.codigoHojaEvaluacion.value;
    if ( valor ) {
      const cuentaContable = this.cuentasContables.find( cu => cu.codigoHojaEvaluacion === valor);
      if (cuentaContable && cuentaContable.idCuentaContable !== this.f.idCuentaContable.value ){
        this.ranIncorrecto = true;
      } else {
        this.ranIncorrecto = false;
      }
    } else {
      this.ranIncorrecto = false;
    }

  }



}
